import { MONTH_NAMES } from './projectAnalysisPeriod'
import type { DetailMonthlyRow } from '../types/projectAnalysis'

export type MonthlyChartPoint = {
  name: string
  periodLabel: string
  year: number
  month: number
  totalHours: number
  billableHours: number
  nonBillableHours: number
  utilizationRate: number
  lateEntriesRate: number
  entriesCount: number
  uniqueUsers: number
  leaveDays: number
  /** Leave converted to hours (1 calendar leave day = 8 h), for trend chart. */
  leaveHours: number
}

export function buildMonthlyChartData(
  monthlyData: DetailMonthlyRow[],
): MonthlyChartPoint[] {
  return monthlyData.map((m) => ({
    name: `${m.year}-${String(m.month).padStart(2, '0')}`,
    periodLabel: `${MONTH_NAMES[(m.month || 1) - 1]} ${m.year}`,
    year: m.year,
    month: m.month,
    totalHours: Math.round(m.total_hours * 100) / 100,
    billableHours: Math.round(m.billable_hours * 100) / 100,
    nonBillableHours: Math.round(m.non_billable_hours * 100) / 100,
    utilizationRate:
      m.total_hours > 0
        ? Math.round((m.billable_hours / m.total_hours) * 1000) / 10
        : 0,
    lateEntriesRate:
      (m.entries_count ?? 0) > 0
        ? Math.round(
            ((m.late_entries_count ?? 0) / (m.entries_count ?? 1)) * 1000,
          ) / 10
        : 0,
    entriesCount: m.entries_count ?? 0,
    uniqueUsers: m.unique_users,
    leaveDays: Math.round((m.leave_days ?? 0) * 10) / 10,
    leaveHours: Math.round((m.leave_days ?? 0) * 8 * 100) / 100,
  }))
}

export const DETAIL_PIE_COLORS = {
  billable: '#22c55e',
  nonBillable: '#f59e0b',
  leave: '#0ea5e9',
} as const
